import { ACTION } from '@/store/CONSTANTS';

const ACTIONS = {
  CREATE_APPOINTMENT: 'create-appointment',
  EDIT_APPOINTMENT: 'edit-appointment',
  CREATE_TASK: 'create-task',
  EDIT_TASK: 'edit-task',
  COMPLETE_TASK: 'complete-task',
  COMPLETE_CALLBACK_REQUEST: 'complete-callback-request',
  SNOOZE_CALLBACK_REQUEST: 'snooze-callback-request',
  COMPLETE_STATUS_PROMPT: 'complete-status-prompt',
};

export default {
  data() {
    return {
      ACTIONS,
      connectTabWatchingInterval: null,
    };
  },
  beforeDestroy() {
    clearInterval(this.connectTabWatchingInterval);
  },
  methods: {
    isCallbackAction(action) {
      return [ACTIONS.SNOOZE_CALLBACK_REQUEST, ACTIONS.COMPLETE_CALLBACK_REQUEST].includes(action);
    },
    isStatusPromptAction(action) {
      return action === ACTIONS.COMPLETE_STATUS_PROMPT;
    },
    isTaskAction(action) {
      return [ACTIONS.CREATE_TASK, ACTIONS.EDIT_TASK, ACTIONS.COMPLETE_TASK].includes(action);
    },
    getActionPath(action) {
      const basePath = `${process.env.VUE_APP_HD_CONNECT}/crm/`;
      const dealPath = `${basePath}deals/${this.deal.uid}/`;

      if (this.isStatusPromptAction(action)) return dealPath;

      if (this.isTaskAction(action)) return `${dealPath}tasks`;

      if (this.isCallbackAction(action)) {
        return `${basePath}buyer_requests/${this.cardDynamicData.buyer_request_uid}`;
      }

      return `${dealPath}appointments`;
    },
    getActionQueryParams(action) {
      const queryParams = new URLSearchParams({
        custom_action: action,
        ...(action === ACTIONS.EDIT_APPOINTMENT && { appointment_uid: this.cardDynamicData.uid }),
        ...(this.isCallbackAction(action) && { callback_request_uid: this.cardDynamicData.uid }),
        ...(this.isStatusPromptAction(action) && { status_prompt_uid: this.cardDynamicData.uid }),
        ...([ACTIONS.EDIT_TASK, ACTIONS.COMPLETE_TASK].includes(action) && {
          task_uid: this.cardDynamicData.uid,
          ...(this.cardDynamicData.key && { task_key: this.cardDynamicData.key }),
        }),
      });
      return queryParams;
    },
    actionHandler(action) {
      if (!(action && Object.values(ACTIONS).includes(action))) return;
      const connectTab = window.open(
        `${this.getActionPath(action)}?${this.getActionQueryParams(action)}`,
        '_blank',
      );
      if (!connectTab) {
        console.error('Unable to open Connect tab');
        return;
      }
      this.connectTabWatchingInterval = setInterval(() => {
        if (connectTab.closed) {
          clearInterval(this.connectTabWatchingInterval);

          this.$store.dispatch(ACTION.DASHBOARD.FETCH_EXPANDED_DEAL, { dealUid: this.deal.uid });
        }
      }, 1000);
    },
  },
};
